import {booleanAttribute, Component, Input} from '@angular/core';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {ApiCisternResponseDto} from '@birco/rainmesh-api';
import {NgStyle} from '@angular/common';
import {LocalizedNumberPipe} from '../../../../shared/pipes/localized-number.pipe';
import {LocalizedPercentPipe} from '../../../../shared/pipes/localized-percent.pipe';
import { IconComponent } from "../../../../shared/icons/icon.component";
import {RouterLink} from '@angular/router';
import {RouteConstants} from '../../../../shared/constants/route-constants';
import {TranslatePipe} from '@ngx-translate/core';
import { TextWithIconComponent } from "../../../../shared/components/text-with-icon/text-with-icon.component";

@Component({
  selector: 'app-cistern-item-card',
  imports: [
    CardComponent,
    LocalizedPercentPipe,
    LocalizedNumberPipe,
    NgStyle,
    IconComponent,
    RouterLink,
    TranslatePipe,
    TextWithIconComponent
],
  templateUrl: './cistern-item-card.component.html',
  styleUrl: './cistern-item-card.component.scss'
})
export class CisternItemCardComponent {
  @Input() cistern?: ApiCisternResponseDto
  @Input() deviceFullAt?: string;
  @Input({transform: booleanAttribute}) navigateToStatistics = false;
  @Input({transform: booleanAttribute}) navigateToDetail = false;
  @Input({transform: booleanAttribute}) withAnimation = true;

  get percent() {
    return this.cistern?.currentWaterPercentage ?? 0
  }

  get absolut() {
    return this.cistern?.currentWaterVolume ?? 0
  }

  get isClickable() {
    return this.navigateToDetail || this.navigateToStatistics;
  }

  get routerLink() {
    if (this.navigateToDetail && this.cistern) {
      return ['/', RouteConstants.routeCistern, this.cistern.id];
    }

    if (!this.navigateToStatistics || !this.cistern) {
      return null;
    }

    return ['/', RouteConstants.routeStatistics];
  }

  get queryParams() {
    if (!this.navigateToStatistics || !this.cistern) {
      return null;
    }

    return {
      cisternId: this.cistern.id,
      chartTab: 'level'
    };
  }
}
